export default "__VITE_ASSET__BLEQkj_c__"